import pick from 'lodash/pick';
import omit from 'lodash/omit';
import isMatch from 'lodash/isMatch';

const selectToCompare = (obj, selectOptions) => {
  let filteredObject = obj;

  if (selectOptions.pick) {
    filteredObject = pick(obj, selectOptions.pick);
  } else if (selectOptions.omit) {
    filteredObject = omit(obj, selectOptions.omit);
  }

  return filteredObject;
};

export const shallowCompare = (current, next, selectOptions = {}) => {
  let isEqual = false;

  if (current === next) {
    isEqual = true;
  } else {
    const currentToCompare = selectToCompare(current, selectOptions);
    const nextToCompare = selectToCompare(next, selectOptions);

    isEqual = isMatch(currentToCompare, nextToCompare);
  }

  return isEqual;
};

export const shallowEqual = (
  instance,
  nextProps,
  nextState,
  { propsSelectOptions, stateSelectOptions },
) =>
  shallowCompare(instance.props, nextProps, propsSelectOptions) &&
  shallowCompare(instance.state, nextState, stateSelectOptions);
